<mat-card>
	<img style="max-width:300px" [src]="organizationService.dynamicUri(service.cardImage)" />
	<mat-card-header  style="margin-top:1em"> 
		<mat-card-subtitle><h3>{{service.name}}</h3></mat-card-subtitle>
	</mat-card-header>	

</mat-card>
